import React from 'react';
import { get, find, /*filter, isNil, head, isEmpty, isEqual, cloneDeep*/ } from 'lodash';

// local dependencies
import { priorAuthorization as PriorAuthorizationView } from 'ui/views/widgets/priorAuthorization';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { PriorAuthorizationService } from 'services/priorAuthorization';

// import { resolveSecondaryOptionsResolver } from 'resolvers/resolveSecondaryOptions';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { PriorAuthorization } from 'ui/containers/PriorAuthorization';
 *
 * // render
 * <PriorAuthorization propName='propValue'/>
 */
export class PriorAuthorization extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = this.composeStateFromProps();

        this._bind();
        this.priorAuthorizationService = new PriorAuthorizationService();
    }

    _bind() {

        this.onFormSubmit = this.onFormSubmit.bind( this );
        this.composeStateFromProps = this.composeStateFromProps.bind( this );

        // this.handleFormChangeCallback = this.handleFormChangeCallback.bind( this );
    }

    composeStateFromProps() {
        log.debug( 'PriorAuthorization.composeStateFromProps()' );

        // const primaryTypeField = find( this.props.fields, function( field ) { return 'primary' === get( field, 'config.fieldType', null ); } );
        // const secondaryTypeField = find( this.props.fields, function( field ) { return 'secondary' === get( field, 'config.fieldType', null ); } );

        log.debug( this.props );
        return {
            options: get( this.props, 'data.options', {} ),
            fields: this.props.fields,
            
            // values: get( this.props, 'values.state.values' ),
            // primaryType: get( this.props, `values.${ primaryTypeField.name }`, undefined ),
            // secondaryType: get( this.props, `values.${ secondaryTypeField.name }`, undefined ),
        };
    }

    // handleFormChangeCallback( { values, field } ) {
    //     log.debug( 'PriorAuthorization.handleFormChangeCallback()' );

    //     /*-------------------*/

    //     const primaryTypeField = find( this.props.fields, function( _field ) { return 'primary' === get( _field, 'config.fieldType', null ); } );
    //     const secondaryTypeField = find( this.props.fields, function( _field ) { return 'secondary' === get( _field, 'config.fieldType', null ); } );
    //     const primaryTypeValue = get( values, `${ primaryTypeField.name }`, undefined );

    //     if( ! isEmpty( primaryTypeValue ) && ! isEqual( primaryTypeValue, this.state.primaryType ) && isEqual( field.name, primaryTypeField.name ) ) {

    //         const { updatedOptions } = resolveSecondaryOptionsResolver( {
    //             values,
    //             options: this.props.data.options,
    //             primaryTypeField,
    //             secondaryTypeField,
    //             fields: this.props.fields
    //         } );

    //         const _values = cloneDeep( values );
    //         values[ `${secondaryTypeField.name}` ] = '';

    //         this.setState( {
    //             values: _values,
    //             primaryType: values[ `${primaryTypeField.name}` ],
    //             secondaryType: '',
    //             options: updatedOptions
    //         } );
    //     }

    //     /*-------------------*/
    // }

    /**
     * action executed when user clicks on form submit
     */
    async onFormSubmit ( formData ) {
        log.debug( 'PriorAuthorization.onFormSubmit()' );

        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.priorAuthorizationService.submitFormData( {
            url: successAction.url,
            data: {
                ...this.props.requestPayload,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <PriorAuthorizationView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.onFormSubmit }

                // onChangeCallBack={ this.handleFormChangeCallback }
            />
        );
    }
}

// set display name
PriorAuthorization.displayName = 'Prior Authorization';

// set default props
PriorAuthorization.defaultProps = {};

// prop types
PriorAuthorization.propTypes = {};
